import {
  Box,
  Fade,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@mui/material'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import { green } from '@mui/material/colors'
import { useTranslation } from 'react-i18next'
import { useBoolean } from 'lib/hooks/use-boolean'
import { useSignOut } from 'api/hooks/use-sign-out'
import { useMatch } from 'react-router-dom'
import { NavItem } from './nav-item'
import { useRef } from 'react'
import { pageConfig } from 'app/page-config'

export const ProfileMenu = () => {
  const match = useMatch('profile/:slug')
  const { t } = useTranslation()
  const onSignOut = useSignOut()
  const open = useBoolean(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const options = [
    {
      title: t('profile'),
      to: pageConfig.orders,
    },
  ]

  return (
    <Box
      ref={anchorRef}
      onMouseEnter={open.setTrue}
      onMouseLeave={open.setFalse}
      sx={{ position: 'relative', flexGrow: 0 }}
    >
      <IconButton
        sx={{ '&:hover': { backgroundColor: green[100] } }}
        size="small"
      >
        <PersonOutlineOutlinedIcon color="success" sx={{ fontSize: '23px' }} />
      </IconButton>
      <Popper
        open={open.isTrue}
        anchorEl={anchorRef.current}
        placement="bottom"
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper
              sx={(theme) => ({
                '&.MuiPaper-elevation.MuiPaper-rounded': {
                  borderRadius: theme.shape.borderRadius.toString(),
                },
              })}
            >
              <MenuList
                id="profile-list"
                aria-labelledby="profile-list"
                sx={{
                  overflow: 'hidden',
                  borderRadius: '6px',
                }}
              >
                {options.map(({ title, to }) => (
                  <NavItem
                    key={title}
                    onClick={open.setFalse}
                    to={to}
                    title={t(title)}
                    match={!!match}
                    styles={{ textAlign: 'center' }}
                  />
                ))}
                <MenuItem onClick={onSignOut} sx={{ justifyContent: 'center' }}>
                  <Typography>{t('sign_out')}</Typography>
                </MenuItem>
              </MenuList>
            </Paper>
          </Fade>
        )}
      </Popper>
    </Box>
  )
}
